import { Stack, Typography } from '@mui/material';

import { ColorsRaw } from '@/ui/theme/colors-raw';

import { ScoreCo2Label } from '../ScoreCo2Label';

export function TextData({
  label,
  value,
  scoreCo2,
  valueColor,
}: {
  label: string;
  value: string;
  scoreCo2: number;
  valueColor?: string;
}) {
  const match = value.match(/^(\d+)(.*)$/);
  const digits = match ? match[1] : '';
  const unit = match ? match[2] : value;
  const valueTextStyle = getBaseTextStyle();
  return (
    <Stack
      sx={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: 1,
        justifyContent: 'space-between',
      }}
    >
      <Stack
        sx={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: 1,
          flexWrap: 'wrap',
        }}
      >
        <Typography
          sx={{ fontSize: '1rem', color: ColorsRaw.secondary.Light_Grey }}
        >
          {label} {' :'}
        </Typography>
        <Typography sx={{ ...valueTextStyle, color: valueColor }}>
          {digits}
        </Typography>
        <Typography sx={{ ...valueTextStyle }}>{unit}</Typography>
      </Stack>
      <ScoreCo2Label
        score={scoreCo2}
        unit="t"
        size="large"
        scoreColor={valueColor}
      />
    </Stack>
  );
}

function getBaseTextStyle() {
  return {
    fontSize: '1.25rem',
    fontWeight: '900',
  };
}
